/**
 * ReunionBackground - Fond "Réunion Premium"
 * 
 * Design: Océan 🌊 + Forêt 🌴 + Volcan 🌋
 * Tortue: 10% opacité (validé)
 * 
 * Version: 5.0.0
 */

import React from 'react';

const ReunionBackground = ({ children, className = '' }) => {
  return (
    <div className={`reunion-bg ${className}`}>
      {/* Tortue watermark - 10% opacité */}
      <div 
        className="reunion-turtle-overlay"
        style={{ backgroundImage: 'url(/turtle-bg.jpg)' }}
        aria-hidden="true"
      />
      {/* Accent océan en haut */}
      <div className="reunion-ocean-accent" aria-hidden="true" />
      {/* Contenu */}
      {children}
    </div>
  );
};

export default ReunionBackground;

// Export aussi sous l'ancien nom pour compatibilité
export { ReunionBackground as TropicalBackground };
